module.exports = __webpack_public_path__ + "assets/img/button-active.315a86bb.svg";